/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Denah_S1Inputs */

const en_tut_denah_s1 = /** @type {(inputs: Tut_Denah_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anyone can take a desk: click an empty one and press **Pakai meja**. It stays yours until you press **Lepas meja**. Decorate it if you like.`)
};

const id_tut_denah_s1 = /** @type {(inputs: Tut_Denah_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siapa pun bisa memakai meja: klik meja kosong lalu **Pakai meja**. Meja tersimpan atas nama Anda sampai ditekan **Lepas meja**. Hiasi lewat dekorasi meja kalau mau.`)
};

/**
* | output |
* | --- |
* | "Anyone can take a desk: click an empty one and press **Pakai meja**. It stays yours until you press **Lepas meja**. Decorate it if you like." |
*
* @param {Tut_Denah_S1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_denah_s1 = /** @type {((inputs?: Tut_Denah_S1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Denah_S1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_denah_s1(inputs)
	return en_tut_denah_s1(inputs)
});